import { render } from "./kycForm.vue?vue&type=template&id=806e6fee&scoped=true&lang=html"
import script from "./kycForm.vue?vue&type=script&lang=js"
export * from "./kycForm.vue?vue&type=script&lang=js"

import "./kycForm.vue?vue&type=style&index=0&id=806e6fee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806e6fee"]])

export default __exports__